import type { OptionSummary } from '@/services/BookingService.interface'

/** Iresa / booking-funnel promo adjustment line (not ski equipment). */
export const PROMO_CODE_FAMILY_IDS = new Set<number>([
  2, // legacy extractor promo rows (booking-lambda)
  57, // FamilyId.PRICE_ADJUSTMENT_PROMO (booking-funnel)
])

export function isPromoCodeOption(option: {
  familyId?: number | null
  name?: string | null
  promoCodeDiscount?: unknown
}): boolean {
  const familyId = option.familyId
  if (familyId != null && PROMO_CODE_FAMILY_IDS.has(familyId)) {
    return true
  }

  if (
    option.promoCodeDiscount != null &&
    String(option.promoCodeDiscount).trim() !== ''
  ) {
    return true
  }

  const name = String(option.name ?? '').trim().toLowerCase()
  return name === 'code promo' || name.startsWith('code promo ')
}

export function isPromoCodeService(service: {
  familyId?: number
  nameCommercial?: string
}): boolean {
  return isPromoCodeOption({
    familyId: service.familyId,
    name: service.nameCommercial,
  })
}
